import BannerGrid from "./BannerGrid.vue";
import BannerSlider from "./BannerSlider.vue";
import BannerTab from "./BannerTab.vue";
import CrmProductSlider from "./CrmProductSlider.vue";
import ProductSlider from "./ProductSlider.vue";
import NewsSlider from "./NewsSlider.vue";
import RecipeSlider from "./RecipeSlider.vue";
import ProductTab from "./ProductTab.vue";
import StaticImage from "./StaticImage.vue";
import StaticText from "./StaticText.vue";
import Tutorial from "./Tutorial.vue";
import FormDetail from "./FormDetail.vue";
import CatalogSlider from "./CatalogSlider.vue";

import kebabCase from "lodash/kebabCase";
import get from "lodash/get";

export default {
  install: app => {
    app.component("category-block", {
      functional: true,
      name: "category-block",
      props: {
        target: {
          type: Object,
          required: false
        },
        position: {
          type: String,
          required: false
        },
        config: {
          type: Object,
          required: false
        },
        container: {
          type: Boolean,
          default: true
        },
        productId: {
          type: Number,
          required: false
        },
        categoryId: {
          type: Number,
          required: false
        }
      },
      render: function(createElement, context) {
        let cfg;
        if (context.props.config) {
          cfg = context.props.config;
        } else if (context.props.position) {
          cfg = context.props.target?.categoryBlocks?.find(
            categoryBlock =>
              categoryBlock.templateBlock.codInt == context.props.position
          );
        } else {
          cfg = context.props.target?.categoryBlocks?.[0];
        }
        if (cfg) {
          // const cmp = defineAsyncComponent({
          //   loader: () => import("@/components/categoryBlock/BannerSlider.vue")
          // });
          let cmp;

          //   = () =>
          //     import(
          //       `@/components/categoryBlock/${cfg.templateBlockType.modeName}.vue`
          //     );
          switch (cfg.templateBlockType.modeName) {
            case "BannerGrid":
              cmp = BannerGrid;
              break;
            case "BannerSlider":
              cmp = BannerSlider;
              break;
            case "BannerTab":
              cmp = BannerTab;
              break;
            case "CrmProductSlider":
              cmp = CrmProductSlider;
              break;
            case "ProductSlider":
              cmp = ProductSlider;
              break;
            case "ProductTab":
              cmp = ProductTab;
              break;
            case "StaticImage":
              cmp = StaticImage;
              break;
            case "StaticText":
              cmp = StaticText;
              break;
            case "Tutorial":
              cmp = Tutorial;
              break;
            case "NewsSlider":
              cmp = NewsSlider;
              break;
            case "RecipeSlider":
              cmp = RecipeSlider;
              break;
            case "FormDetail":
              cmp = FormDetail;
              break;
            case "CatalogSlider":
              cmp = CatalogSlider;
              break;
          }
          /*
              <ebsn-style
      :target="config"
      :path="`categoryblocktype_${name}.CSS_STYLE`"
      :styleWrapper="`#product-list-slider-${config.categoryBlockId}`"
    />
    */
          if (cmp) {
            const id = `category-block-${cfg.categoryBlockId}`;
            const componentName = kebabCase(cfg.templateBlockType.modeName);
            let content = [];
            let style = app.$ebsn.meta(
              cfg,
              `categoryblocktype_${cfg.templateBlockType.modeName}.CSS_STYLE`
            );
            if (style) {
              let value = style.replace(
                /([^\r\n,{};(?!@)]+)(,|{)/g,
                `#${id}` + " " + "$1$2"
              );
              content.push(
                createElement(
                  "style",
                  {
                    attrs: {
                      type: "text/css"
                    }
                  },
                  value
                )
              );
            }
            content.push(
              createElement(cmp, {
                props: {
                  id: id,
                  config: cfg,
                  container: context.props.container,
                  productId: context.props.productId,
                  categoryId: context.props.categoryId
                },
                style: createStyle(cfg, cfg.templateBlockType.modeName)
              })
            );
            if (context.props.container) {
              content = createElement("div", { staticClass: "container" }, [
                content
              ]);
            }
            return createElement(
              "div",
              {
                attrs: {
                  id: id
                },
                staticClass: `${componentName} ${id}`,
                on: {
                  hide: function(event, a) {
                    console.log(event);
                    console.log(a);
                  }
                }
              },
              [content]
            );
            // return createElement(cmp, {
            //   props: {
            //     id: id,
            //     config: cfg,
            //     container: context.props.container,
            //     productId: context.props.productId,
            //     categoryId: context.props.categoryId
            //   },
            //   staticClass: context.data.staticClass
            // });
          }
        }
        return null;
        function createStyle(config, optionsName) {
          let style = {};
          let backgroundColor = get(
            config,
            `metaData.categoryblocktype_${optionsName}.BACKGROUND_COLOR`
          );
          if (backgroundColor) {
            style.backgroundColor = backgroundColor;
          }
          //queste prop sono obsolete perchè si possono usare i custom styles
          // let backgroundImage = get(
          //   config,
          //   `metaData.categoryblocktype_${optionsName}.BACKGROUND_IMAGE.location`
          // );

          // if (backgroundImage) {
          //   style.backgroundImage = `url("${backgroundImage}")`;
          //   let backgroundPosition =
          //     get(
          //       config,
          //       `metaData.categoryblocktype_${optionsName}.BACKGROUND_POSITION`
          //     ) || "top center";
          //   style.backgroundPosition = backgroundPosition;
          // }
          // style.paddingTop = get(
          //   config,
          //   `metaData.categoryblocktype_${optionsName}.BACKGROUND_PADDING`
          // );

          return style;
        }
      }
    });
  }
};
